import React, {useState,useEffect} from "react";
import "../styles/about.css";
import axios from "axios";
// const partners = [
//   {
//     name: "Google",
//     theme: "google-card",
//     image:
//       "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80",
//     shortTitle: "Digital learning and AI awareness",
//     description:
//       "Our Google partnership helps communities access digital education, AI awareness, cloud fundamentals, and employability-focused workshops. It supports learners with practical tools and future-ready skills.",
//     highlights: ["AI Workshops", "Cloud Basics", "Digital Skills", "Career Support"],
//   },
//   {
//     name: "Prodash",
//     theme: "microsoft-card",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
//     shortTitle: "Productivity, cloud, and job readiness",
//     description:
//       "Through Microsoft, learners can gain exposure to productivity tools, Azure concepts, workplace readiness, and upskilling opportunities that improve confidence and practical employability.",
//     highlights: ["Office Skills", "Azure Learning", "Career Readiness", "Professional Growth"],
//   },
//   {
//     name: "Microsoft",
//     theme: "microsoft-card",
//     image:
//       "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80",
//     shortTitle: "Productivity, cloud, and job readiness",
//     description:
//       "Through Microsoft, learners can gain exposure to productivity tools, Azure concepts, workplace readiness, and upskilling opportunities that improve confidence and practical employability.",
//     highlights: ["Office Skills", "Azure Learning", "Career Readiness", "Professional Growth"],
//   },
//   {
//     name: "AWS",
//     theme: "aws-card",
//     image:
//       "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1200&q=80",
//     shortTitle: "Cloud pathways and practical technology exposure",
//     description:
//       "With AWS-focused programs, communities can explore cloud careers, foundational architecture concepts, lab-based learning, and modern digital pathways that support long-term growth.",
//     highlights: ["AWS Basics", "Hands-on Labs", "Cloud Careers", "Tech Exposure"],
//   },
// ];

// const benefits = [
//   {
//     icon: "🤝",
//     title: "Strong Credibility",
//     description:
//       "Partnerships with trusted global brands improve community trust, visibility, and stakeholder confidence.",
//   },
//   {
//     icon: "💡",
//     title: "Modern Learning Access",
//     description:
//       "NGOs can provide high-quality digital, cloud, and AI-focused learning experiences to different groups.",
//   },
//   {
//     icon: "🌍",
//     title: "Greater Community Reach",
//     description:
//       "These collaborations help expand impact across students, women returners, professionals, and graduates.",
//   },
//   {
//     icon: "📈",
//     title: "Better Employability",
//     description:
//       "Programs linked with real industry tools improve job readiness, practical confidence, and career pathways.",
//   },
//   {
//     icon: "🧠",
//     title: "Innovation Exposure",
//     description:
//       "Learners gain access to emerging ideas such as AI, automation, cloud workflows, and digital transformation.",
//   },
//   {
//     icon: "🏢",
//     title: "Corporate Collaboration",
//     description:
//       "This creates room for long-term support through mentoring, sponsorships, workshops, and strategic training.",
//   },
// ];


const AboutPartnership = () => {
  const [partners, setPartners] = useState([]);
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/2.0/about-partnership`);
        const result = await response;
        console.log(result.data.success)
        if (result.data.success) {
          setPartners(result.data.data.partners || []);
          setBenefits(result.data.data.benefits || []);
        }
      } catch (error) {
        console.error("Error fetching about partnership data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);
  return (
    <div className="about-page-wrap">
      <div className="about-glow about-glow-one" />
      <div className="about-glow about-glow-two" />

      <section className="about-hero">
        <div className="about-hero-content">
          <span className="about-pill">Strategic Partnership Ecosystem</span>
          <h1>About Our Partnership Network</h1>
          <p>
            Udyog Connect is building partnerships with leading technology
            ecosystems such as Google, Microsoft, and AWS to create inclusive
            digital learning, employability pathways, AI awareness, and
            future-ready community programs.
          </p>

          <div className="about-hero-stats">
            <div className="about-stat-card">
              <h3>3</h3>
              <span>Global ecosystems</span>
            </div>
            <div className="about-stat-card">
              <h3>12+</h3>
              <span>Skill pathways</span>
            </div>
            <div className="about-stat-card">
              <h3>4</h3>
              <span>Community segments</span>
            </div>
          </div>
        </div>

        <div className="about-hero-visual">
          <div className="about-hero-image-card">
            <img
              src="https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1200&q=80"
              alt="Technology partnership"
            />
            <div className="about-hero-overlay">
              <span className="about-tag">Partnership-led impact</span>
              <h3>Building community growth through modern technology</h3>
              <p>
                Our collaborations connect underserved communities to practical,
                industry-aligned learning opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <div className="section-title-block">
          <span className="section-mini-label">Partner Segments</span>
          <h2>About each partnership</h2>
          <p>
            Each partner brings a different strength to the ecosystem, from AI
            awareness and productivity tools to cloud career pathways.
          </p>
        </div>

        <div className="partner-segment-grid">
          {partners.map((partner) => (
            <div key={partner.name} className={`partner-segment-card ${partner.theme}`}>
              <div className="partner-segment-image">
                <img src={partner.image} alt={partner.name} />
              </div>

              <div className="partner-segment-content">
                <span className="partner-name-chip">{partner.name}</span>
                <h3>{partner.shortTitle}</h3>
                <p>{partner.description}</p>

                <div className="partner-highlight-list">
                  {partner.highlights.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-section">
        <div className="section-title-block">
          <span className="section-mini-label">Why It Matters</span>
          <h2>How These Partnerships Strengthen Our Mission</h2>
          <p>
            These partnerships do not just add visibility. They strengthen
            program design, improve reach, and create more meaningful learning
            outcomes.
          </p>
        </div>

        <div className="benefit-grid">
          {benefits.map((item, index) => (
            <div key={index} className="benefit-tile">
              <div className="benefit-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutPartnership;